import { render } from "./CommentItem.vue?vue&type=template&id=a1f36d62"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/polls/partials/CommentItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1f36d62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1f36d62', __exports__)) {
    console.log('reload')
    api.reload('a1f36d62', __exports__)
  }
  
  module.hot.accept("./CommentItem.vue?vue&type=template&id=a1f36d62", () => {
    console.log('re-render')
    api.rerender('a1f36d62', render)
  })

}


export default __exports__